import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { SavedSearchDto } from '@creditsights/api-ui-web';
// eslint-disable-next-line import/no-unresolved
import { navbarSyncDataSubject$, SyncDataSubject } from '@creditsights/navbar-web';
import { Channels } from '../../utils/channels';
import { queryKeys } from '../queryKeyFactory';
import { ApiError } from '../../services/api-error.model';
import { updateSavedSearch } from '../../services/searches/savedSearches.service';

export default (): UseMutationResult<SavedSearchDto, ApiError, SavedSearchDto, void> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (savedSearch: SavedSearchDto) => {
      return updateSavedSearch(savedSearch);
    },
    {
      onSuccess: async (savedSearch) => {
        queryClient.invalidateQueries([queryKeys.fetchSavedSearches.all]);
        await Channels.savedSearchesChannel.postMessage(null);
        navbarSyncDataSubject$.next(SyncDataSubject.SAVED_SEARCH);
        return savedSearch;
      },
    }
  );
};
